import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MenuService } from './services/menu.service';
import { GlobalService } from './services/global.service';

import { ModalService } from './shared/modal/modal.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  name: string;
  menu: Array<any> = [];
  breadcrumbList: Array<any> = [];
  changeText: boolean;
  displayFAB: boolean = false;

  constructor(private _router: Router, private menuService: MenuService, private global: GlobalService,private modalService: ModalService) {
    this.changeText = false;
  }


  ngOnInit() {
    // 取得MenuService裡的menu
    this.menu = this.menuService.getMenu();
    this.listenRouting();
    //console.log('go hit from app comp');
  }

  ngDoCheck(){
    if(!this._router.url.includes('login') 
    && !this._router.url.includes('register') 
    && !this._router.url.includes('sign-up') 
    && !this._router.url.includes('forgotPassword') 
    && !this._router.url.includes('resetPassword')
    && this.global.displayFAB){
      //if on a public page, dont display FAB support button
      this.displayFAB = true;
    }else{
      this.displayFAB = false;
    }
  }

  listenRouting() {
    let routerUrl: string, routerList: Array<any>, target: any;
    this._router.events.subscribe((router: any) => {
      routerUrl = router.urlAfterRedirects;
      
      if (routerUrl && typeof routerUrl === 'string' && !routerUrl.includes('resetPassword')) { //this removes the resetpassword link from the routing check
       
        target = this.menu;
        this.global.breadcrumbList.length = 0;
     
        routerList = routerUrl.slice(1).split('/');
        routerList.forEach((router, index) => {
         
          target = target.find(page => page.path.slice(2) === router);
          //console.log('go here:', target);
          
          if (target) {
            this.global.breadcrumbList.push({
              name: target.name,//(target.name === undefined) ? '/' : target.name,
              path: (index === 0) ? target.path : `${this.global.breadcrumbList[index-1].path}/${target.path.slice(2)}`
            });
          }
          
          if (index+1 !== routerList.length) {
            target = target.children;
          }
        });
        this.global.breadcrumbList = this.breadcrumbList;
        //console.log('breadcrumb',this.breadcrumbList);
      }
    });
  }

  handleContactUsModal(e) {
    this.modalService.add('contact-support', { ID: Number(localStorage.getItem("userId"))});
  }
}

